import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import { getCurrentCategoryPath } from './useCurrentCategory.helpers';
import {
  Category,
  GetCategoryDetailsResponse,
} from '@/api/types/categories.types';
import { GET_CATEGORY_DETAILS } from '@/api/queries/categories.queries';

type UseGetCurrentCategoryDetailsReturn = {
  categoryDetails?: Category;
};

interface Props {
  skip?: boolean;
}

export function useCurrentCategoryDetails({
  skip = false,
}: Props = {}): UseGetCurrentCategoryDetailsReturn {
  const {
    query: { slug },
  } = useRouter();

  const { data } = useQuery<GetCategoryDetailsResponse>(GET_CATEGORY_DETAILS, {
    variables: { path: getCurrentCategoryPath(slug) },
    skip,
  });

  return {
    categoryDetails: data?.category,
  };
}
